import React, { useState, useEffect } from 'react';
import { urlMiniatura } from '../utils/fotoThumb';

// Miniatura de foto de visita: tenta a versão reduzida (~25KB, gerada pela Cloud Function
// `gerarMiniaturaFoto`) e cai na original (~220KB) se ela ainda não existir — foto anterior ao
// backfill, ou trigger que ainda não rodou. O fallback é o que deixa o deploy seguro em qualquer
// ordem. Espelha mobile/src/components/FotoThumb.tsx.
export default function FotoThumb({ uri, ...props }: { uri: string } & React.ImgHTMLAttributes<HTMLImageElement>) {
  const [src, setSrc] = useState<string>(urlMiniatura(uri) || uri);
  useEffect(() => { setSrc(urlMiniatura(uri) || uri); }, [uri]);
  return (
    <img
      {...props}
      src={src}
      loading="lazy"
      alt={props.alt ?? ''}
      onError={() => { if (src !== uri) setSrc(uri); }}
    />
  );
}
